import AroundSlider from '@/common/components/camera/components/ImageSlider/components/AroundSlider/AroundSlider';
import DamagedPointSlider from '@/common/components/camera/components/ImageSlider/components/DamagedPointSlider/DamagedPointSlider';
import { ImageSliderPropsType } from '@/common/components/camera/types/components.type';

const ImagesSlider = ({
  turn,
  sliderData,
  isVehicle,
  vehicleType,
}: ImageSliderPropsType) => {
  if (turn === 0 && isVehicle) {
    return null;
  }
  return (
    <>
      {isVehicle ? (
        <AroundSlider sliderData={sliderData.vehicle} turn={turn} />
      ) : null}
      {!isVehicle ? (
        <DamagedPointSlider
          vehicleType={vehicleType}
          sliderData={sliderData.damaged_parts}
          turn={turn - sliderData.vehicle.length}
        />
      ) : null}
    </>
  );
};

export default ImagesSlider;
